import { ImportReferenceTypeEditForm } from 'application/import-reference-type/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { ImportReferenceTypeService } from 'application/import-reference-type/services';
import { action } from 'mobx';

@applicationContext
class ImportReferenceTypeEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new ImportReferenceTypeService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'role',
            id: id,
            Form: ImportReferenceTypeEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: ImportReferenceTypeEditForm,
        });
    }

    onCreateError(err) {
        if (!this.errorActions.onCreateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Reference Type already exists.' : err.data.message : `Error occurred while trying to update a Reference Type.`
            );
            return;
        }
        return this.errorActions.onCreateError(err)
    }

    onUpdateError(err) {
        if (!this.errorActions.onUpdateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Reference Type already exists.' : err.data.message : `Error occurred while trying to update a Reference Type.`
            );
            return;
        }
        return this.errorActions.onUpdateError(err);
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('IMPORT_REFERENCE_TYPE.CREATE.SUCCESS_CREATE');
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('IMPORT_REFERENCE_TYPE.EDIT.SUCCESS_UPDATE', name);
    }
}

export default ImportReferenceTypeEditViewStore;
